// extracted by mini-css-extract-plugin
export default {"placeholder":"index-module--placeholder--f6661","footer":"index-module--footer--0263c"};